import { Component, OnInit } from "@angular/core";
import { KlinikService } from "../services/klinik.service";
import { Klinik } from "./klinik";
import { Klinikrandevu } from "./klinikrandevu";
import { Odabilgisi } from "./odabilgisi";
import { TarihListesi } from "./tarih-listesi";
import { Serviscevap } from "../models/serviscevap";
import { RandevuHastaListesi } from "../randevulistesi/randevu-hasta-listesi";
import { Router } from "@angular/router";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogBoxComponent } from "../dialog-box/dialog-box.component";
import { JwtHelperService } from "@auth0/angular-jwt";

@Component({
  selector: "app-randevu-ver",
  templateUrl: "./randevu-ver.component.html",
  styleUrls: ["./randevu-ver.component.css"],
})
export class RandevuVerComponent implements OnInit {
  hastaReferans: string;
  hastaTelefon: string;
  hastaAdisoyadi: string;
  hastaYasi: string;

  jwtHelper: JwtHelperService = new JwtHelperService();
  decodeToken: any;

  tarih: string;
  mesaj: string;
  mesajOnay: boolean;
  mesajBaslik: string;
  mesajSMS: string;

  klinikBilgisi: Klinik[];
  klinikOdaBilgisi: Odabilgisi[];
  klinikrandevu: Klinikrandevu[];
  tarihListesi: TarihListesi[];
  servisCevap: Serviscevap[];
  rndHListesi: RandevuHastaListesi[];

  selectedklinik: Klinik[];
  selectedOda: Odabilgisi[];
  selectedTarih: TarihListesi[];

  constructor(
    private klinikService: KlinikService,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.decodeToken = this.jwtHelper.decodeToken(
      localStorage.getItem("TurcaSoft")
    );
    this.hastaAdisoyadi = this.decodeToken["_hAdi"];
    this.hastaReferans = this.decodeToken["_hRef"];
    this.hastaTelefon = this.decodeToken["_hCeptelefon"];
    this.hastaYasi = this.decodeToken["_hYas"];

    this.getKlinikList();
  }

  getKlinikList() {
    this.klinikService.getKlinik().subscribe((data) => {
      this.klinikBilgisi = data;
    });
  }

  getKlinikOdalistesi(klinikBilgisi) {
    this.selectedklinik = klinikBilgisi;
    this.tarihListesi = [];
    this.klinikrandevu = [];
    if (
      parseInt(this.hastaYasi) >= this.selectedklinik["fYasA"] &&
      parseInt(this.hastaYasi) <= this.selectedklinik["fYasB"]
    ) {
      this.klinikService.getOdaBilgisi(klinikBilgisi).subscribe((response) => {
        this.klinikOdaBilgisi = response;
      });
    } else {
      this.mesajOnay = false;
      this.openDialog(
        "Lütfen Dikkat!",
        "Hastanın yaşı " +
          this.selectedklinik["fName"] +
          " için uygun değildir!",
        "Tamam",
        null,
        null,
        false
      );
    }
  }

  getTarihListesi(Odabilgisi) {
    this.selectedOda = Odabilgisi;
    this.klinikrandevu = [];

    this.klinikService.getTarihListesi(Odabilgisi).subscribe((data) => {
      this.tarihListesi = data;

      if (this.tarihListesi.length == 0) {
        this.mesajOnay = false;
        this.openDialog(
          "Lütfen Dikkat!",
          this.selectedklinik["fName"] +
            " kliniği " +
            this.selectedOda["fName"] +
            " için randevu kotası dolmuştur!",
          "Tamam",
          null,
          null,
          false
        );
      }

      // this.getKlinikRandevuSablon(Odabilgisi);
    });
  }

  getRandevuListesi(tListesi) {
    this.selectedTarih = tListesi;
    tListesi.fKlinikRef = this.selectedklinik["fId"];
    tListesi.fOdaRef = this.selectedOda["fId"];
    this.getKlinikRandevuSablon(tListesi);
  }

  getKlinikRandevuSablon(tListesi) {
    this.klinikService.getRandevuSablon(tListesi).subscribe((response) => {
      this.klinikrandevu = response;
    });
  }

  randevuOnay(klinikrandevu: Klinikrandevu) {
    this.mesajBaslik = "Randevu Sonuç!";
    klinikrandevu.smsMesaj = this.mesajSMS;
    klinikrandevu.cepTelefon = this.hastaTelefon;

    if (this.mesajOnay) {
      this.klinikService.randevuKayit(klinikrandevu).subscribe((response) => {
        this.servisCevap = response;
        if (response["sonucKodu"] == 1) {
          klinikrandevu.fHasta = 0;
          this.mesaj = response["sonucAciklama"];
        } else if (response["sonucKodu"] == 0) {
          this.mesajBaslik = response["sonucAciklama"];
          this.mesaj =
            "Randevu saatinizden 15 dakika önce görüşme linkiniz cep telefonunuza mesaj olarak gönderilecektir. Sağlıklı günler dileriz.";
        } else this.mesaj = response["sonucAciklama"];

        this.openDialog(
          this.mesajBaslik,
          this.mesaj,
          null,
          "Tamam",
          null,
          false
        );
      });
    } else klinikrandevu.fHasta = 0;
  }

  butonSecildi(klinikrandevu: Klinikrandevu) {
    klinikrandevu.fHasta = Number(this.hastaReferans);
    klinikrandevu.fKlinikRef = this.selectedklinik["fId"];
    this.mesajOnay = false;
    // this.mesajSMS =
    //   this.selectedTarih["fTarih"] +
    //   " tarih ve " +
    //   klinikrandevu["saat"] +
    //   " saatinde " +
    //   this.selectedklinik["fName"] +
    //   " kliniğinde " +
    //   this.selectedOda["fName"] +
    //   " için randevu isteğiniz onaylanmıştır. Randevu saatinizden 15 dakika önce görüşme linkiniz cep telefonunuza mesaj olarak gönderilecektir. Sağlıklı günler dileriz.";

    this.mesajSMS =
      this.selectedTarih["fTarih"] +
      " tarih ve " +
      klinikrandevu["saat"] +
      " saatinde " +
      this.selectedklinik["fName"] +
      " kliniğinde " +
      this.selectedOda["fName"] +
      " için görüntülü muayene randevu isteğiniz onaylanmıştır. Bu randevu için evinizde akıllı telefon veya kamerası bulunan bir bilgisayar bulundurmanız gerekmektedir. Randevu saatinizden 15 dakika önce görüşme linkiniz cep telefonunuza mesaj olarak gönderilecektir. Görüntülü muayeneniz sonucnda online görüştüğünüz diş hekiminiz size klinik randevusu oluşturacaktır. Sağlıklı günler dileriz. #evdekal";

    this.mesaj =
      this.selectedTarih["fTarih"] +
      " tarih ve " +
      klinikrandevu["saat"] +
      " saatinde " +
      this.selectedklinik["fName"] +
      " kliniğinde " +
      this.selectedOda["fName"] +
      " için randevu isteğini onaylıyor musunuz?";

    this.openDialog(
      "Lütfen Dikkat!",
      this.mesaj,
      "Evet",
      "Hayır",
      klinikrandevu,
      true
    );
  }

  getHRandevuList() {
    this.router.navigateByUrl("randevu-listesi");
  }

  openDialog(
    _baslik: string,
    _mesaj: string,
    _bntOk: string,
    _btnIptal: string,
    data: any,
    durum: boolean
  ): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "40%";

    let dialogRef = this.dialog.open(DialogBoxComponent, {
      disableClose: true,
      autoFocus: true,
      width: "45%",

      data: {
        baslik: _baslik,
        mesaj: _mesaj,
        bntOk: _bntOk,
        btnIptal: _btnIptal,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!this.mesajOnay) data.fHasta = 0;
    });

    const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(
      (result) => {
        ///  dialogSubmitSubscription.unsubscribe();

        this.mesajOnay = true;
        if (durum) this.randevuOnay(data);
      }
    );
  }

  kapat() {
    localStorage.removeItem("TurcaSoft");
    return this.router.navigateByUrl("randevu-islemleri");
  }
}
